import { render, staticRenderFns } from "./Instruction.vue?vue&type=template&id=056a504f"
import script from "./Instruction.vue?vue&type=script&lang=js"
export * from "./Instruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('056a504f')) {
      api.createRecord('056a504f', component.options)
    } else {
      api.reload('056a504f', component.options)
    }
    module.hot.accept("./Instruction.vue?vue&type=template&id=056a504f", function () {
      api.rerender('056a504f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vendor/firegroup/fire-core-formgenerator/src/assets/vue/frontend/elements/Instruction.vue"
export default component.exports